<template>
  <div>
    <div class="top_bar_ clearfix_">
      <div class="w1000_">
        <!-- <div v-if="!isLogined" class="left_ f_l_">
                    欢迎登录{{storeName}}，请
                    <span class="c11_">
                        <router-link class="c11_" :to="{name: 'gd-login'}">登录</router-link>
                    </span>
                </div>
                <div v-else class="left_ f_l_"><span @click="loginOut()" style="cursor:pointer">退出登录</span></div> -->

        <div class="right_ f_r_">
          <!-- <a class="mrg_r36_"><router-link :to="{name: 'gd-home'}">首页</router-link></a> -->
          <!-- <a class="mrg_r36_" style=" margin-left:30px;" :href="introduceUrl"  target="_blank">公司介绍</a>
                    <a class="mrg_r36_" style=" margin-left:30px;"><router-link :to="{name: 'claimsGuide'}">理赔指引</router-link></a>
                    <a class="mrg_r36_" style=" margin-left:30px;"><router-link :to="{name: 'service'}">救援服务</router-link></a>
                    <a class="vline_" style=" margin-left:30px;"> <router-link :to="{name: 'commonQuestion'}">常见问题</router-link></a>
                    <a class="javascript:void(0)"><router-link  :to="{name: 'contactUs'}">联系我们</router-link></a> -->
        </div>
      </div>
    </div>
    <div class="top1_ w1000_ w1200_">
      <img class="logo_" :src="logoUrl" />
      <!-- <div class="search_wrap_">
                <a-input v-model="keyword" @change="onSearchChange" @focus="onSearchChange" @blur="onSearchBlur" class="input_search_" placeholder="安联“申根之王”欧洲旅行保险"></a-input>
                <a-button @click="onSearch" size="large" class="btn_search_" type="primary">搜索</a-button>
                <ul role="listbox" tabindex="0" v-if="showKeywordList" class="keyword_list_">
                    <li role="option" @click="handleSearch(item)" v-for="item in keywordList">{{item}}</li>
                </ul>
            </div> -->
      <div class="f_r_">
        <!-- <div class="item_ c11_">
                    <i class="i_icon_ i_service_"></i>
                    <div>服务中心</div>
                </div> -->
        <!-- <div class="vline_"></div> -->
        <div class="item_ c11_" @click="goHome()" style="cursor:pointer">
          <i class="i_icon_ i_order_"></i>
          <div>首页</div>
        </div>
        <div class="item_ c11_" @click="goPolicy()" style="cursor:pointer">
          <i class="i_icon_ i_order_"></i>
          <div>服务中心</div>
        </div>
        <div class="item_ c11_" @click="loginOut()" style="cursor:pointer">
          <i class="i_icon_ i_order_"></i>
          <div>退出登录</div>
        </div>
        <!-- <div class="vline_"></div>
                <div class="item_ c11_" @click="godetail()" style="cursor:pointer">
                    <i class="i_icon_ i_product_"></i>
                    <div>产品列表</div>
                </div> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.top_bar_ {
  background: #001d3b;
  color: #fff;
  font-size: 12px;
  line-height: 33px;
  height: 33px;
  .left_ {
    white-space: nowrap;
  }
  .vline_ {
    &::after {
      display: inline-block;
      vertical-align: middle;
      content: "";
      width: 1px;
      height: 13px;
      background: #fff;
      margin: 0px 18px;
      margin-top: -1px;
    }
  }
  a {
    color: #fff;
  }
}
.top1_ {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 238px;
    height: 56px;
    margin: 13px 0 15px 0;
    object-fit: cover;
  }
  .search_wrap_ {
    position: relative;
    display: inline-block;
    margin: auto 69px auto 95px;

    .input_search_ {
      width: 258px;
      height: 42px;
      border-radius: 0;
    }
    .btn_search_ {
      width: 88px;
      height: 42px;
      border-radius: 0;
      box-shadow: none;
    }
    .keyword_list_ {
      position: absolute;
      left: 0px;
      right: 88px;
      top: 100%;
      z-index: 666;
      line-height: 28px;
      border: 1px solid #f5692c;
      border-top: none;
      min-height: 200px;
      max-height: 300px;
      overflow-y: auto;
      background: #fff;
      font-size: 16px;
      li {
        padding-left: 20px;
        cursor: pointer;
        &:hover {
          background: #f5692c;
          color: #fff;
        }
      }
    }
  }
  .f_r_ {
    display: flex;
    align-items: center;
    vertical-align: middle;
    margin: 13px 0 15px 0;
    color: #ff4c1c;
  }
  .item_ {
    margin: 0 10px;
    display: inline-block;
    .i_icon_ {
      display: block;
      width: 16px;
      height: 17px;
      margin: 0 auto 8px;
      &.i_service_ {
        background: url("../../../assets/wxmall/4.png") no-repeat;
        background-size: 100% auto;
      }
      &.i_order_ {
        background: url("../../../assets/wxmall/5.png") no-repeat;
        background-size: 100% auto;
      }
      &.i_product_ {
        background: url("../../../assets/wxmall/6.png") no-repeat;
        background-size: 100% auto;
      }
    }
  }
  .vline_ {
    display: inline-block;
    vertical-align: middle;
    &::after {
      display: inline-block;
      content: "";
      width: 1px;
      height: 26px;
      background: rgba(0, 0, 0, 0.1);
      margin: auto 25px;
    }
  }
}
</style>
<script>
import Storage from "@/utils/storage";
import api from "@/utils/api";
import {
  getToken,
  setToken,
  getLogined,
  getUserInfo,
  setLogined,
  cacheUserInfo,
} from "@/utils/authorized";
const KEY = "_history_search_keyword";

export default {
  data() {
    return {
      showKeywordList: false,
      keywordList: [],
      keyword: "",
      isLogined: getUserInfo() ? true : false,
      logoUrl: "",
      servicePhone: "",
      storeName: "",
      introduceUrl: "",
      myArray: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let userId = 792713; //后台配置用户:GDSC01 GDsc01-01
      if (window.location.href.indexOf("run4wd") > -1) {
        userId = 720369;
      }
      api
        .queryStore({
          userId: userId, //生产
        })
        .then((res) => res.data)
        .then((data) => {
          if (data.returnCode === "00" && data.content != "") {
            this.logoUrl = data.content.coreStoreDto.logoUrl;
            this.servicePhone = data.content.coreStoreDto.servicePhone;
            this.storeName = data.content.coreStoreDto.storeName;
          }
        });
      api
        .getCorePcstore()
        .then((res) => res.data)
        .then((data) => {
          if (data.returnCode === "0000" && data.data != "") {
            this.introduceUrl = data.data.companyIntroduceUrl;
          }
        });
    },
    handleSearch(item) {
      console.log("item -> ", item);
      this.keyword = item;
      // this.$emit('search', this.keyword)
    },
    onSearchBlur() {
      let st = setTimeout(() => {
        this.showKeywordList = false;
        clearTimeout(st);
      }, 300);
    },
    onSearchChange(e) {
      console.log("onSearchChange -> ", e);
      // if (!this.showKeywordList) {
      this.keywordList = Storage.get(KEY);
      this.showKeywordList = true;
      // }
      console.log(this.keywordList, Storage.get(KEY), 1);
    },
    onSearch() {
      const keyword = this.keyword;
      console.log("onSearch -> ", keyword);
      const arr = Storage.addItem(KEY, keyword);
      this._productName = keyword;
      this.$emit("search", keyword);
      console.log(Storage.get(KEY), "保存的搜索数据");
    },
    godetail() {
      console.log(getToken(), "getToken()");
      if (getToken()) {
        let routeUrl = this.$router.resolve({
          path: "/sd",
          query: { sign: getToken() },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        var num = Math.ceil(Math.random() * 10);
        window.router.push({ name: "login", params: { num } });
      }
    },
    loginOut() {
      setLogined(0);
      setToken("");
      cacheUserInfo("");
      this.$router.push({
        name: "gd-login",
      });
    },
    goHome() {
      this.$router.push({ name: "gd-home" });
    },
    goPolicy() {
      let user = getUserInfo();
      if (!this.isLogined) {
        this.$router.push({
          name: "gd-login",
        });
      } else {
        if (user.userName == "8631000038") {
          this.$router.push({
            path: "/gdpolicy/flordered",
          });
        } else {
          //光大商城测试账号、TODO:上生产时需要加个生产的账号
          this.$router.push({
            path: "/gdpolicy/ordered",
          });
        }
      }
    },
  },
};
</script>
